import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UnauthorizedToken from './UnAuthorisedPage';

const ValidToken = () => {
  const navigate = useNavigate();
  const [unauthorised, setUnauthorised] = useState(false)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      localStorage.setItem('authTokenAi', token);
      navigate('/ai-agent');
    } else {
      setUnauthorised(true)
      console.warn('No token found in URL.');
    }
  }, [navigate]);

  return (
    <div>
      {
        unauthorised ? <UnauthorizedToken /> : null
      }
    </div>
  );
};

export default ValidToken;

